<app-header></app-header>

<div class="home-sales-section mt-2">
    <div class="container">
      <div class="row align-items-center pb-5">
        <div class="col-sm-12 pb-4 col-lg-6">
          <div>
            <h1 class="battery-heading">Battery Solutions</h1>
          </div>
          <hr />
          <div>
            <p>Confidence in clean energy when you need it most</p>
            <div class="sales-read-more mt-5">
              <a href="#">Read More</a>
            </div>
          </div>
        </div>
        <div class="col-sm-12 col-lg-6">
          <div class="home-sales-image">
            <img src="/assets/home1.jpg" alt="Home Sales Event"/>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="select-option">
    <div class="container">
      <div class="row pt-sm-0 pt-md-5 pt-lg-5 pb-5">
        <div class="col-sm-12 col-lg-4 pl-sm-2 pl-md-2 pl-lg-4 details-card1">
          <div class="text-center">
            <img src="/assets/home.png" alt="Home Image" />
          </div>
          <h2 class="battery-heading mt-4">Comfort and Confidence in Your Home</h2>
          <p>
            When disasters strike and a power outage occurs, it can be
            unnerving for family members, children, and even you. Basic
            comforts like refrigeration, Wi-Fi, and lights — or necessary
            items like medical equipment — are unavailable or compromised. A
            battery backup system removes those worries and brings a level of
            comfort and confidence to you and your family. A battery backup
            system will provide seamless power to critical load circuits in an
            outage, and it can run indefinitely when paired with a solar
            system. No long gas station lines or running around for fuel or a
            generator during an already stressful time — comfort and
            convenience are already right at home.
          </p>
        </div>
        <div class="col-sm-12 col-lg-4 pl-sm-2 pl-md-2 pl-lg-4 details-card2">
          <div class="text-center">
            <img src="/assets/current.png" alt="Empower Image" />
          </div>
          <h2 class="battery-heading mt-4">Empower Yourself</h2>
          <p>
            Hurricanes, wildfires, heatwaves, rolling blackouts, and rising
            utility rates that suddenly show up in a monthly bill can all
            leave one feeling powerless. A battery backup system empowers you
            to be in control during these unpredictable situations, make the
            best choices for you, and protect against rising costs. Battery
            backup systems can be programmed for versatility — including
            emergency backup power, avoiding utility electricity usage, or
            creating savings by shifting your solar system energy production
            to be used during primary times of use. With a battery backup
            system, control and potential savings are in your hands.
          </p>
        </div>
        <div class="col-sm-12 col-lg-4 pl-sm-2 pl-md-2 pl-lg-4 details-card3">
          <div class="text-center">
            <img src="/assets/thum.png" alt="Feel Good Image"/>
          </div>
          <h2 class="battery-heading mt-4">Feel Good While Doing Good</h2>
          <p>
            With a solar system, you are already making a statement and taking
            a step toward mitigating climate change. Home battery systems
            expand the versatility and impact of your solar system — and your
            mark on the world. Battery systems can be programmed to store
            excess energy from solar to provide power to your home day and
            night, eliminating the dependency on fossil fuel generation. The
            battery may also offer additional energy savings through better
            management of Time-of-Use (TOU) rates. That’s impact and potential
            savings you can feel good about.
          </p>
        </div>
      </div>
    </div>
  </div>
  <div class="sales-fqa-section">
    <div class="container pt-sm-0 pt-md-5 pt-lg-5 pb-5">
      <div class="row align-items-center">
        <div class="col-sm-12 col-md-6 col-lg-6">
          <div>
            <h1 class="battery-heading mt-4">Why Spruce?</h1>
          </div>
          <hr />
          <div>
            <p>
              Spruce is committed to providing clean energy solutions that
              make a difference for you and our world. We own over 50,000
              systems, and manage and maintain over 80,000. This allows us to
              bring the best products at a competitive price, easily install
              your system using our extensive partner service network, and
              wrap it all in a convenient and affordable financing package.
              Spruce up your home today with one of our system expansion
              offerings!
            </p>
          </div>
        </div>
        <div class="col-sm-12 col-md-6 col-lg-6">
          <div class="sales-image">
            <img src="/assets/weather.jpg" alt="Weather Image"/>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="slider-section">
    <div class="container">
      <div
        id="carouselExampleIndicators"
        class="carousel slide"
        data-ride="carousel"
        data-interval="false"
      >
      <div class="carousel-indicators">
        <button
          type="button"
          data-bs-target="#carouselExampleIndicators"
          data-bs-slide-to="0"
          class="active"
          aria-current="true"
          aria-label="Slide 1"
        ></button>
        <button
          type="button"
          data-bs-target="#carouselExampleIndicators"
          data-bs-slide-to="1"
          aria-label="Slide 2"
        ></button>
        <button
          type="button"
          data-bs-target="#carouselExampleIndicators"
          data-bs-slide-to="2"
          aria-label="Slide 3"
        ></button>
        <button
          type="button"
          data-bs-target="#carouselExampleIndicators"
          data-bs-slide-to="3"
          aria-label="Slide 3"
        ></button>
      </div>
        <div class="carousel-inner">
          <div class="carousel-item active">
            <div class="row m-0 text-center align-items-center mt-5">
              <div class="col-sm-12 col-md-6 col-lg-6 p-0">
                <img
                  class="slider-image"
                  src="/assets/house1.jpg"
                  alt="First slide"
                />
              </div>
              <div class="col-sm-12 col-md-6 col-lg-6 slider-text">
                <h1 class="battery-heading">Emergency Backup Power</h1>
              </div>
            </div>
          </div>
          <div class="carousel-item">
            <div class="row text-center align-items-center mt-5">
              <div class="col-sm-12 col-md-6 col-lg-6 p-0">
                <img
                  class="slider-image"
                  src="/assets/house2.jpg"
                  alt="First slide"
                />
              </div>
              <div class="col-sm-12 col-md-6 col-lg-6 slider-text">
                <h1 class="battery-heading">Self-Powered Home & 24/7 Access to Your Solar Energy</h1>
              </div>
            </div>
          </div>
          <div class="carousel-item">
            <div class="row text-center align-items-center mt-5">
              <div class="col-sm-12 col-md-6 col-lg-6 p-0">
                <img
                  class="slider-image"
                  src="/assets/house3.jpg"
                  alt="First slide"
                />
              </div>
              <div class="col-sm-12 col-md-6 col-lg-6 slider-text">
                <h1 class="battery-heading">Shift Your Solar Production to Provide Savings</h1>
              </div>
            </div>
          </div>
          <div class="carousel-item">
            <div class="row text-center align-items-center mt-5">
              <div class="col-sm-12 col-md-6 col-lg-6">
                <img
                  class="slider-image"
                  src="/assets/house4.jpg"
                  alt="First slide"
                />
              </div>
              <div class="col-sm-12 col-md-6 col-lg-6 slider-text">
                <h1 class="battery-heading">Affordable in an Attractive Finance Package</h1>
              </div>
            </div>
          </div>
          <div class="carousel-item">
            <div class="row text-center align-items-center mt-5">
              <div class="col-sm-12 col-md-6 col-lg-6">
                <img
                  class="slider-image"
                  src="/assets/house5.jpg"
                  alt="First slide"
                />
              </div>
              <div class="col-sm-12 col-md-6 col-lg-6 slider-text">
                <h1 class="battery-heading">Solar + Battery + Smart Panel = Home Energy Control</h1>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="battery-steps-section mt-5">
    <div class="ml-5 mr-5 text-center">
      <h2 class="steps-heading">Simple Steps to Obtain a Battery System</h2>
      <hr />
    </div>
    <div class="container inner-steps-section">
      <div class="row">
        <div class="col-xs-12 col-sm-6 col-md-6 col-lg-3 text-center p-2">
          <div class="battery-images">
            <img src="/assets/headphone.png" alt="Battery image"/>
          </div>
          <h4 class="image-heading">Sign up for a consultation.</h4>
        </div>
        <div class="col-xs-12 col-sm-6 col-md-6 col-lg-3 text-center p-2">
          <div class="battery-images">
            <img src="/assets/power.png" alt="Power image"/>
          </div>
          <h4 class="image-heading">
            Assess your household consumption and comfort needs.
          </h4>
        </div>
        <div class="col-xs-12 col-sm-6 col-md-6 col-lg-3 text-center p-2">
          <div class="battery-images">
            <img src="/assets/battery.png" alt="Battery image"/>
          </div>
          <h4 class="image-heading">Determine the “Right Fit” solution.</h4>
        </div>
        <div class="col-xs-12 col-sm-6 col-md-6 col-lg-3 text-center p-2">
          <div class="battery-images">
            <img src="/assets/installation.png" alt="Installation image"/>
          </div>
          <h4 class="image-heading">
            Sign your Spruce agreement and Install.
          </h4>
        </div>
      </div>
    </div>
  </div>
  <div class="sqruce-battery-section mt-sm-0 mt-md-5 mb-5">
    <div class="container">
      <div class="text-center">
        <h2 class="steps-heading">Spruce Battery Options</h2>
        <hr />
        <p>
          We’ve done the work to find the best battery solutions from the
          leading manufacturers. Let us help design the optimal configuration
          for you.
        </p>
      </div>
    </div>
  </div>
  <div class="enphase-section mt-sm-0 mt-md-5">
    <div class="container">
      <div class="row">
        <div class="col-sm-12 col-lg-6 text-center">
          <div class="text-center">
            <h2 class="steps-heading">Enphase IQ</h2>
            <hr />
            <p>Efficient. Modular. Affordable.</p>
          </div>
          <div class="enphase-left-image">
            <img src="/assets/Enphase.png" alt="Emphase image"/>
          </div>
          <a href="#" class="battery-click-button mt-4 mb-4"> Click Here </a>
        </div>
        <div class="col-sm-12 col-lg-6 text-center">
          <div class="text-center">
            <h2 class="steps-heading">Tesla Powerwall</h2>
            <hr />
            <p>Power Everything.</p>
          </div>
          <div class="enphase-right-image">
            <img src="/assets/Tesla.png" alt="Tesla Image"/>
          </div>
          <a href="#" class="battery-click-button mt-4 mb-4"> Click Here </a>
        </div>
      </div>
    </div>
  </div>
  <div class="battery-bundles-section">
    <div class="container">
      <div class="text-white">
        <h2 class="battery-heading">Battery Backup Bundles.</h2>
        <div class="line"></div>
        <h4 class="battery-bundles-heading text-center mt-2">
          Let us help find the right bundle for you.
        </h4>
      </div>
      <div class="row mt-5 inner-battery-plate">
        <div
          class="col-xs-12 col-sm-6 col-md-6 col-lg-3 text-center d-flex flex-column justify-content-between"
        >
          <div class="plate-images">
            <img src="/assets/plate1.png" alt="battery card image"/>
          </div>
          <div class="battery-card-footer">
            <div>
              <h4 class="mt-4 text-white">Essential Comforts Bundle</h4>
              <p class="text-white">1 Enphase battery Lumin Smart Panel</p>
            </div>
            <a href="#">Schedule a Consult</a>
          </div>
        </div>
        <div
          class="col-xs-12 col-sm-6 col-md-6 col-lg-3 text-center d-flex flex-column justify-content-between"
        >
          <div class="plate-images">
            <img src="/assets/plate2.png" alt="Creature comfort image"/>
          </div>
          <div class="battery-card-footer">
            <div>
              <h4 class="mt-4 text-white">Creature Comforts Bundle</h4>
              <p class="text-white">
                2x Tesla Powerwall batteries Lumin or Span Electrical Smart
                Panel
              </p>
            </div>
            <a href="#">Schedule a Consult</a>
          </div>
        </div>
        <div
          class="col-xs-12 col-sm-6 col-md-6 col-lg-3 text-center d-flex flex-column justify-content-between"
        >
          <div class="plate-images">
            <img src="/assets/plate2.png" alt="footer image"/>
          </div>
          <div class="battery-card-footer">
            <div>
              <h4 class="mt-4 text-white">Premiere Energy Bundle</h4>
              <p class="text-white">
                2x Tesla Powerwall batteries Lumin or Span Electrical Smart
                Panel 4kW system expansion
              </p>
            </div>
            <a href="#">Schedule a Consult</a>
          </div>
        </div>
        <div
          class="col-xs-12 col-sm-6 col-md-6 col-lg-3 text-center d-flex flex-column justify-content-between"
        >
          <div class="plate-images">
            <img src="/assets/plate3.png" alt="custom bundle image"/>
          </div>
          <div class="battery-card-footer">
            <div>
              <h4 class="mt-4 text-white">Custom Bundle</h4>
              <p class="text-white">
                We’ll help you find the right solution for your home
              </p>
            </div>
            <a href="#">Schedule a Consult</a>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="Schedule-section">
    <div class="container">
      <div class="row text-center">
        <div class="col-12">
          <h2 class="battery-heading">
            Not sure which option is the best solution for you? Schedule a
            consultation with our experts.
          </h2>
        </div>
        <div class="col-12">
          <div class="contact-button mt-5 mb-4">
            <a class="text-white" [routerLink]="['/get-in-touch']">Contact Us</a>
          </div>
        </div>
        <div class="col-sm-12 col-lg-6 schedule-address">
          <h2 class="mt-4">Give us a call</h2>
          <a href="tel:+18886360336">
            <h2 style="color: #0c71c3">888-636-0336</h2>
          </a>
        </div>
        <div class="col-sm-12 col-lg-6 schedule-address">
          <h2 class="mt-4">Email us at</h2>
          <a href="mailto:{{email}}" ><h2 style="color: #0c71c3">{{email}}</h2></a>
        </div>
      </div>
    </div>
  </div>

  <app-footer></app-footer>
